import { useFormik, FormikProvider, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import * as bie from 'react-bootstrap';
import { config } from '../CommonUtils/CommonURLS';
import { ERROR_MSG } from '../CommonUtils/contextVariables';
import allowNumbersOnly from '../CommonUtils/CommonValidations';
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin2Line } from "react-icons/ri";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FcInfo } from "react-icons/fc";
// Hooks & Components
import { useRusaMasterData } from "./hooks/useRusaMasterData";
import { useRusaFormSubmit } from "./hooks/useRusaFormSubmit";
import {
    WorkDetailsSelect,
    OtherWorkInput,
    ProgressSelect,
    StartDateInput,
    GeoTaggedPdf,
    deleteWithConfirm
} from "./components/RusaFormFields";
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { currentMonth, currentYear } from '../CommonUtils/CommonServices';
import { viewImage } from '../CommonUtils/viewImage';

const SoftComponent = () => {
    const { worksList } = useRusaMasterData();
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);
    const validationSchema = Yup.object({
        rusaPhase: Yup.string().required(ERROR_MSG).nullable(),
        constructionType: Yup.string().required(ERROR_MSG),
        otherWork: Yup.string().when("constructionType", {
            is: "99",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        progressOfWork: Yup.string().required(ERROR_MSG),
        conductedAt: Yup.string().when("progressOfWork", {
            is: "completed",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        noOfPatricipants: Yup.string().when("progressOfWork", {
            is: "completed",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        geoTaggedPhotos: Yup.string().when("progressOfWork", {
            is: "completed",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),

        startDate: Yup.string().when("progressOfWork", {
            is: "ongoing",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        dateOfCompletion: Yup.string().when("progressOfWork", {
            is: "completed",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        compId: Yup.string().required(ERROR_MSG).nullable(),

    });
    const { submitForm } = useRusaFormSubmit();


    const formik = useFormik({
        initialValues: {
            rusaPhase: "",
            constructionType: "",
            otherWork: "",
            progressOfWork: "",
            conductedAt: "",
            noOfPatricipants: "",
            geoTaggedPhotos: "",
            startDate: "",
            dateOfCompletion: "",
            compId: ""
        },
        validationSchema: validationSchema,

        onSubmit: (val) => {

            const editing = isEdit;

            const valueOrNull = (v) =>
                v !== "" && v !== undefined && v !== null ? v : null;

            const payload = {
                scheme: valueOrNull(val.rusaPhase),
                compType: "4",
                constructionType: valueOrNull(val.constructionType),
                equipmentOtherText: valueOrNull(val.otherWork),
                noOfUnitsConstructed: '',
                compId: val?.compId,
                activityStatus: valueOrNull(val.progressOfWork),
                startDate: val.startDate,
                dateOfCompletion: val.dateOfCompletion,
                percOfCompletion: '',
                status: '',
                constructionPhoto: '',
                facilityUtilised: '',
                briefDescription: '',
                videoLink: '',
                month: currentMonth,
                year: currentYear,
                completed: '',
                subEquipId: '',
                conductedAt: valueOrNull(val.conductedAt),
                noOfParticipate: valueOrNull(val.noOfPatricipants),
                uploadActivityReport: valueOrNull(val.geoTaggedPhotos),
            };


            const apiUrl = editing
                ? `${config.url.API_URL}updateInfraWorks?sno=${editId}`
                : `${config.url.API_URL}saveRusaInfradtls`;

            const confirmText = editing
                ? "Are you sure you want to update?"
                : "Are you sure you want to submit?";

            // ✅ Submit
            submitForm(
                payload,
                () => {
                    console.log("✅ Submit success → refreshing data");

                    // ✅ Always refresh after save & edit
                    GetSoftData();

                    formik.resetForm();
                    setIsEdit(false);
                    setEditId(null);
                },
                apiUrl,
                confirmText
            );
        }

    });
    const [component, setComponent] = useState([]);
    const [phasename, setPhasename] = useState([]);

    function GetComponentData(phase) {

        console.log("GetComponentData called with phase:", phase);
        if (!phase) return;
        const url = `${config.url.API_URL}getRusaComponentList?rusa_phase=${phase}`;
        CommonAxiosGet(url).then((res) => {
            setComponent(res?.data?.scode === "01" ? res.data.data : []);
        });

    }
    function GetSoftScheme() {
        const url = `${config.url.API_URL}getPhase`;
        CommonAxiosGet(url).then((res) => {
            setPhasename(res?.data?.scode === "01" ? res.data.phase : []);
        });
    }

    const ReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },

        {
            id: "scheme",
            header: "Scheme",
            accessorKey: "scheme",
        },

        {
            id: "comp_name",
            header: "Component Name",
            accessorKey: "comp_name",
            size: 1300, // adjust width in pixels
            cell: ({ row }) => {
                const Comp = row.original.comp_name;
                const otherWork = row.original.otherwork;
                return (
                    <div >
                        {Comp && Comp.trim() !== "" ? Comp : otherWork}
                    </div>
                );
            },
        },
        {
            id: "sub_comp_name_works",
            header: "Name of the Activity",
            accessorKey: "sub_comp_name_works",
            cell: ({ row }) => {
                const Construction = row.original.construction_type;
                const otherWork = row.original.equipment_other_text;
                const subcompname = row.original.sub_comp_name_works;
                return (
                    <div>
                        {Construction && Construction == "99" ? otherWork : subcompname}
                    </div>
                );
            },
        },


        {
            id: "activity_status",
            header: "Status of the Activity",
            accessorKey: "activity_status",
        },


        {
            id: "start_date",
            header: "Start Date",
            accessorKey: "start_date",
        },
        {
            id: "date_of_completion",
            header: "Date of Completion",
            accessorKey: "date_of_completion",
        },
        {
            id: "no_of_participate",
            header: "No.of Participants- Faculty/Students/Others",
            accessorKey: "no_of_participate",
        },
        {
            id: "conducted_at",
            header: "Conducted At",
            accessorKey: "conducted_at",
        },




        {
            id: "brief_description",
            header: "Uploaded Pdf",
            accessorKey: "brief_description",
            cell: ({ row }) => {
                const fileUrl = row.original?.upload_activity_report;

                if (!fileUrl) return null;

                return (
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        title="View File"
                        onClick={() => viewImage(fileUrl)}
                    >
                        <BsFileEarmarkPdf size={18} />
                    </button>
                );
            },
        },

        /* ================= EDIT / DELETE ================= */
        // {
        //     id: "actions", // ✅ mandatory
        //     header: "Edit / Delete",
        //     cell: ({ row }) => {
        //         const rowData = row.original;

        //         return (
        //             <div className="d-flex gap-2">
        //                 {/* ✏️ EDIT */}
        //                 <button
        //                     type="button"
        //                     className="btn btn-primary btn-sm"
        //                     onClick={() => {
        //                         formik.setValues({
        //                             rusaPhase: rowData?.scheme || "",
        //                             compId: rowData?.comp_id || "",
        //                             subCompId: rowData?.sub_comp_id || "",
        //                             constructionType: rowData?.construction_type,
        //                             progressOfWork: rowData?.activity_status,
        //                             startDate: rowData?.start_date,
        //                             dateOfCompletion: rowData?.date_of_completion,
        //                             conductedAt: rowData?.conducted_at,
        //                             geoTaggedPhotos: rowData?.upload_activity_report,

        //                             noOfPatricipants: rowData?.no_of_participate,
        //                             ...(rowData?.construction_type == "99" && {
        //                                 otherWork: rowData?.equipment_other_text,
        //                             }),

        //                         });

        //                         setIsEdit(true);
        //                         setEditId(rowData?.sno);
        //                         GetComponentData(rowData?.scheme);
        //                     }}
        //                 >
        //                     <FaEdit size={16} />
        //                 </button>

        //                 {/* 🗑️ DELETE */}
        //                 <button
        //                     type="button"
        //                     className="btn btn-danger btn-sm"
        //                     onClick={() => {
        //                         Swal.fire({
        //                             title: "Are you sure?",
        //                             text: "Do you want to delete this record?",
        //                             icon: "warning",
        //                             showCancelButton: true,
        //                             confirmButtonText: "Yes, delete it!",
        //                         }).then((result) => {
        //                             if (result.isConfirmed) {
        //                                 const url = `${config.url.API_URL}deleteInfraWorks?sno=${rowData?.sno}`;
        //                                 CommonAxiosPost(url)
        //                                     .then((res) => {
        //                                         if (res?.data?.scode === "01") {
        //                                             Swal.fire(res?.data?.sdesc, "", "success");
        //                                             GetSoftData();
        //                                         } else {
        //                                             Swal.fire("Delete failed", "", "error");
        //                                         }
        //                                     })

        //                             }
        //                         });
        //                     }}
        //                 >
        //                     <RiDeleteBin2Line

        //                         size={20} />
        //                 </button>
        //             </div>
        //         );
        //     },
        // },
        {
            id: "actions",
            header: "Edit / Delete",
            cell: ({ row }) => {
                const rowData = row.original;

                return (
                    <div className="d-flex gap-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                formik.setValues({
                                    rusaPhase: rowData?.scheme || "",
                                    compId: rowData?.comp_id || "",
                                    subCompId: rowData?.sub_comp_id || "",
                                    constructionType: rowData?.construction_type,
                                    progressOfWork: rowData?.activity_status,
                                    startDate: rowData?.start_date,
                                    dateOfCompletion: rowData?.date_of_completion,
                                    conductedAt: rowData?.conducted_at,
                                    geoTaggedPhotos: rowData?.upload_activity_report,
                                    noOfPatricipants: rowData?.no_of_participate,
                                    ...(rowData?.construction_type === "99" && {
                                        otherWork: rowData?.equipment_other_text,
                                    }),
                                });

                                setIsEdit(true);
                                setEditId(rowData?.sno);
                                GetComponentData(rowData?.scheme);
                            }}
                        >
                            <FaEdit size={16} />
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                console.log("DELETE BUTTON CLICKED");
                                console.log("ROW DATA:", rowData);
                                console.log("SNO:", rowData?.sno);

                                deleteWithConfirm({
                                    sno: rowData?.sno,
                                    apiPath: "deleteInfraWorks",
                                    onSuccess: GetSoftData,
                                });
                            }}
                        >
                            <RiDeleteBin2Line size={20} />
                        </button>

                    </div>
                );
            },
        }
    ];




    const [softdata, setSoftdata] = useState([]);
    function GetSoftData() {
        let url = `${config.url.API_URL}getInfraWorksSoft?month=${currentMonth}&year=${currentYear}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" &&
                res?.data?.["soft"]?.length > 0) {
                setSoftdata(res.data["soft"]); // ✅ correct
            } else {
                setSoftdata([]);
            }
        });
    }
    useEffect(() => {
        GetSoftScheme();
        GetSoftData();
    }, [])


    const ongoingClearFields = [
        "startDate",


    ];

    const completedClearFields = [
        "dateOfCompletion",
        "conductedAt",
        "noOfPatricipants",
        "geoTaggedPhotos",


    ];
    return (
        <bie.Container fluid className="px-0">
            <bie.Container className="px-0 pt-3 mw-100 pb-5">
                <div className="overal-stathead">
                    <span>  SoftComponent </span></div>
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <bie.Row className="g-3">
                            <bie.Col lg={4}>
                                <label>Scheme</label>
                                <Field as="select" name="rusaPhase" className="form-control"
                                    onChange={(e) => {
                                        formik.handleChange(e);        // ✅ update Formik state
                                        GetComponentData(e.target.value); // ✅ your custom logic
                                    }}
                                >
                                    <option value="">--select--</option>
                                    {phasename?.map((p) => (
                                        <option key={p.rusa_phase} value={p.rusa_phase}>
                                            {p.rusa_phase}
                                        </option>
                                    ))}


                                </Field>
                                <ErrorMessage name="rusaPhase" component="div" className="text-danger" />

                            </bie.Col>

                            {/* Component */}
                            <bie.Col lg={4}>
                                <label>Component</label>
                                <Field as="select" name="compId" className="form-control" >
                                    <option value="">--select--</option>

                                    {component?.map((c) => (
                                        <option key={c.comp_id} value={c.comp_id}>
                                            {c.component_name}
                                        </option>
                                    ))}

                                </Field>
                                <ErrorMessage name="compId" component="div" className="text-danger" />

                            </bie.Col>
                            <WorkDetailsSelect
                                works={worksList?.soft}
                                label="Name of the Activity"
                            />

                            {formik?.values?.constructionType === "99" && <OtherWorkInput />}

                            {/* <ProgressSelect
                                name="progressOfWork"
                                label="Status of the Activity"
                            /> */}
                            <ProgressSelect
                                label="Status of the Activity"
                                formik={formik}
                                ongoingClearFields={ongoingClearFields}
                                completedClearFields={completedClearFields}
                            />

                            {formik?.values?.progressOfWork === "ongoing" && (
                                <StartDateInput label="Proposed Date" />
                            )}

                            {formik?.values?.progressOfWork === "completed" && (
                                <>
                                    {/* <EndDateInput label="Completed Date" /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                        <label className="mb-1"> Date of Completion </label>
                                        <Field type="date" name="dateOfCompletion" className="form-control" />
                                        <ErrorMessage name="dateOfCompletion" component="div" className="text-danger" />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                        <label className="mb-1">Conducted At</label>
                                        <Field name="conductedAt" className="form-control" />
                                        <ErrorMessage name="conductedAt" component="div" className="text-danger" />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                        <label className="mb-1">No.of Participants- Faculty/Students/Others</label>
                                        <Field name="noOfPatricipants" className="form-control" onKeyPress={allowNumbersOnly} />
                                        <ErrorMessage name="noOfPatricipants" component="div" className="text-danger" />
                                    </bie.Col>
                                    {/* 
                                    <GeoTaggedPdf
                                        name="geoTaggedPhotos"
                                        label={
                                            <>
                                                Upload a detailed report of the activity, along with photographs, covering the objectives, schedule, resource persons, participants, feedback, outcomes, and press clippings, including geo-tagged photographs.
                                            </>
                                        }
                                        formik={formik}
                                    /> */}


                                    <GeoTaggedPdf
                                        name="geoTaggedPhotos"
                                        label={
                                            <div className="d-flex align-items-center gap-2">
                                                <span>Upload Report</span>

                                                <OverlayTrigger
                                                    placement="right"
                                                    overlay={
                                                        <Tooltip id="geo-tooltip">
                                                            Upload a detailed report of the activity, along with photographs,
                                                            covering the objectives, schedule, resource persons, participants,
                                                            feedback, outcomes, and press clippings, including geo-tagged photographs.
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span style={{ cursor: "pointer" }}>
                                                        <FcInfo size={20} />
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                        }
                                        formik={formik}
                                    />

                                </>
                            )}
                        </bie.Row>
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-success">
                                {isEdit ? "Update" : "Submit"}
                            </button>
                        </div>

                        {softdata?.length > 0 && (
                            <>

                                <div className="overal-stathead">
                                    <span>  SoftComponent Report</span></div>
                                <div className="all-table-content">
                                    <div className="table-responsive mt--40">
                                        <CommonReactTable
                                            data={softdata}
                                            columns={ReportColumns}
                                            filename="Institute Wise Financial Report"
                                            headerName="Institute Wise Financial Report"
                                            showFooter={true}
                                            showPagination={false}

                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </Form>
                </FormikProvider>
            </bie.Container>
        </bie.Container>
    );
};

export default SoftComponent;
